import React, { useEffect, useState } from "react";
import "./PatientProfile.css";
import Profile from "../../assets/images/profile-img.png";
import { Button, Col, Input, Nav, NavItem, NavLink, Row, TabContent, TabPane } from "reactstrap";
import { useLocation, useNavigate } from "react-router";
import { getPatientById, updatePatientById } from "../../api/patient";
import { decryptData, maskSSN } from "../../utils/helper";
import { useDispatch, useSelector } from "react-redux";
import { failed, success } from "../../utils/Tostify";
import { calculateAge } from "../../utils/DateSupport";
import Loader from "../../components/Loader/Loader";
import { decryptPatientData, maskString } from "../../utils/common";
import DocumentList from "./DocumentList";
import AddPatientPortal from "./addpatient/AddPatientPortal";
import moment from "moment";
import AddApplications from "./addpatient/AddApplications";
import PatientActivity from "./addpatient/PatientActivity";
import { AI_CARE } from "../../utils/constants";
import AddHouseHold from "./addpatient/AddHouseHold";
import { enrollmentOptions, legalImmigrationOptions } from "./Constant";
import noProfileImg from "../../../src/assets/images/noImage.jpg";

const PatientProfile = () => {
    const user = useSelector((state) => state?.userReducer?.user);
    localStorage.setItem("prevRoute2", window.location.pathname);
    const [activeTab, setActiveTab] = useState('1');
    const location = useLocation();
    const id = location?.state?.patientData || null;
    const [isLoading, setIsLoading] = useState(false);
    const [patientDetails, setPatientDetails] = useState();
    const dispatch = useDispatch();
    let token = useSelector((state) => state.userReducer.token);
    const navigate = useNavigate();
    const [statusFilter, setStatusFilter] = useState('InProcess');
    const patientIdFromState = location.state?.id;
    const userRole = localStorage.getItem('userRole');

    const toggleTab = (tab) => {
        if (activeTab !== tab) setActiveTab(tab);
    };

    const handleStatusChange = (status) => {
        setStatusFilter(status); // Set the filter status
    };

    const getPatient = async () => {
        let res;
        try {
            setIsLoading(true);
            res = await getPatientById({ dispatch, token, id: id || patientIdFromState, userId: user?._id });
            const responseData = decryptData(res.data);
            const decryptedPatient = await decryptPatientData(responseData);
            if (res?.status === "SUCCESS") {
                setPatientDetails(decryptedPatient);
                setIsLoading(false);
            }
        } catch (error) {
            failed(res?.message);
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if (id) {
            getPatient();
        }
    }, [id]);

    useEffect(() => {
        if (patientIdFromState) {
            getPatient();
        }
    }, [patientIdFromState]);

    const handleEdit = async (fieldType) => {
        let res;
        let values = {};
        try {
          setIsLoading(true);
          if (fieldType === "archieve") {
            values = { archieve: !patientDetails?.archieve };
          } else if (fieldType === "medicaidSubscriberIDNumber") {
            values = { medicaidSubscriberIDNumber: patientDetails?.medicaidSubscriberIDNumber };
          }
          res = await updatePatientById({ payload: values, dispatch, token, patientId: patientDetails?._id });
          if (res?.status === "SUCCESS") {
            await getPatient(); // refresh patient details after save
            setIsLoading(false);
            success(res?.message);
          } else {
            setIsLoading(false);
            failed(res?.message);
          }
        } catch (error) {
          setIsLoading(false);
          failed(error?.message || "Something went wrong");
        }
    };

    const prevRoute = localStorage.getItem("prevRoute");

    return (
        <>
            <div className="patient_profile_container">
                {isLoading ? <Loader /> : null}
                <h2 className="home-title">Patient  Information - <span>{patientDetails && patientDetails?.name?.text}</span></h2>
                <div className="profile_info">
                    <div className="profile_blk_block">
                        <div className="profile_information d-flex align-items-center flex-wrap gap-3">
                            <div className="d-flex profile_blk">
                                <img src={patientDetails?.profile_image ? patientDetails?.profile_image.signedUrl : noProfileImg} alt="" className="profile_image" />
                                <h3 className="profile_name my-3">{patientDetails?.name?.text}</h3>
                            </div>
                            <div className="d-flex button_blk flex-wrap">
                                <button
                                    className="btn_grey"
                                    onClick={() => {
                                        navigate("/clinic/add-patient", {
                                            state: {
                                                patientDetails,
                                                activeTab,
                                                isEditMode: prevRoute === "/clinic/patient-list" ? true : false,
                                                isEditMode2: prevRoute === "/app/application-detail" ? true : false
                                            }
                                        });
                                    }}
                                >
                                    Edit
                                </button>
                                {userRole !== 'Patient' && (
                                    <button className="btn_grey saving" onClick={() => handleEdit("archieve")}>
                                        {patientDetails?.archieve ? "Unarchive" : "Archive"}
                                    </button>
                                )}
                                {userRole !== 'Patient' && (
                                <span className="patient_portal_block button_po" style={{ padding: "0px" }}>
                                    <button disabled={!patientDetails?.staffId || patientDetails?.system_ai_care === "No" || patientDetails?.system_ai_care === "None" || patientDetails?.archieve === true || patientDetails?.applications?.some(app => app.status === "InProcess")
}
                                        onClick={() => {
                                            navigate("/app/start-application",
                                                {
                                                    state: {
                                                        patientDetails: patientDetails,
                                                        isRouteMode: prevRoute === "/app/application-detail" ? true : false,
                                                        isRouteMode2: prevRoute === "/clinic/patient-list" ? true : false
                                                    }
                                                });
                                        }}
                                    >
                                        Start Application
                                    </button>
                                    {(!patientDetails?.staffId ||
                                        patientDetails?.system_ai_care === "No" ||
                                        patientDetails?.system_ai_care === "None" ||
                                        patientDetails?.archieve === true ||
                                        patientDetails?.applications?.some(app => app.status === "InProcess")) && (
                                        <div className="disabled-reason" style={{ marginTop: "10px", color: "red", fontSize: "12px" }}>
                                            {!patientDetails?.staffId && <p>To start application assign patient to staff member.</p>}
                                            {patientDetails?.system_ai_care === "No" && <p>Application cannot be initiated. Patient is not eligible for Medicaid</p>}
                                            {patientDetails?.system_ai_care === "None" && <p>Application cannot be initiated. Patient is not eligible for Medicaid</p>}
                                            {patientDetails?.archieve === true && <p>Patient is Archived</p>}
                                            {patientDetails?.applications?.some(app => app.status === "InProcess") && <p>Application cannot be initiated. Patient application already is In-Process</p>}
                                        </div>
                                    )}
                                </span>
                                )}
                            </div>
                        </div>
                        <div className="table-responsive">
                            <table>
                                <thead>
                                    <tr className="header_table">
                                        <th>Age</th>
                                        <th> Gender</th>
                                        <th>State</th>
                                        <th>Date of Birth</th>
                                        <th>MRN Number</th>
                                        <th>Coverage</th>
                                        <th>Household Size</th>
                                        <th>Household Income</th>
                                        <th>Discharged Status</th>
                                        <th>DOA</th>
                                        <th>{AI_CARE}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            {patientDetails && calculateAge(moment(patientDetails?.birthDate).format("DD-MM-YYYY"))}
                                        </td>
                                        <td>
                                            {patientDetails && patientDetails?.gender}
                                        </td>
                                        <td>
                                            {patientDetails && patientDetails?.address?.state}
                                        </td>
                                        <td>
                                            {patientDetails && patientDetails?.birthDate}
                                        </td>
                                        <td>{patientDetails?.mrnNumber}</td>
                                        <td>{patientDetails?.coverage ? "Yes" : "No"}</td>
                                        <td>{patientDetails?.houseHoldSize ? patientDetails?.houseHoldSize : 1}</td>
                                        <td>${patientDetails?.houseHoldIncome}</td>
                                        <td>{patientDetails?.discharged_status ? "Yes" : "No"}</td>
                                        <td>{moment(patientDetails?.doa).format("MM-DD-YYYY")}</td>
                                        {/* <td>{<button className={`btn_status ${patientDetails?.system_ai_care === "Yes" ? "yes" : patientDetails?.system_ai_care === "No" ? "no" : ""}`}>{AI_CARE} : {patientDetails?.system_ai_care === "Yes" ? "Yes" : patientDetails?.system_ai_care === "No" ? "No" : "None"}</button>}</td> */}
                                        <td>
                                        {
                                            <button
                                            className={`btn_status ${
                                                patientDetails?.houseHoldIncome === null
                                                ? "None"
                                                : patientDetails?.system_ai_care === "Yes" || patientDetails?.houseHoldIncome === 0
                                                ? "yes"
                                                : patientDetails?.system_ai_care === "No"
                                                ? "no"
                                                : ""
                                            }`}
                                            >
                                            {AI_CARE} :{" "}
                                            {patientDetails?.houseHoldIncome === null
                                                ? "None"
                                                : patientDetails?.system_ai_care === "Yes" || patientDetails?.houseHoldIncome === 0
                                                ? "Yes"
                                                : patientDetails?.system_ai_care === "No"
                                                ? "No"
                                                : "None"}
                                            </button>
                                        }
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div className="tab_blk">
                        <div>
                            <Nav tabs className="profile_intab horizontal-scroll">
                                <NavItem>
                                    <NavLink
                                        className={activeTab === '1' ? 'active' : ''}
                                        onClick={() => toggleTab('1')}
                                    >
                                        Personal
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className={activeTab === '2' ? 'active' : ''}
                                        onClick={() => toggleTab('2')}
                                    >
                                        Household
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className={activeTab === '3' ? 'active' : ''}
                                        onClick={() => toggleTab('3')}
                                    >
                                        Documents
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className={activeTab === '4' ? 'active' : ''}
                                        onClick={() => toggleTab('4')}
                                    >
                                        Contact
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className={activeTab === '5' ? 'active' : ''}
                                        onClick={() => toggleTab('5')}
                                    >
                                        Insurance
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className={activeTab === "6" ? "active" : ""}
                                        onClick={() => toggleTab("6")}
                                    // disabled={!isPatientCreated}
                                    >
                                        Portal
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className={activeTab === "7" ? "active" : ""}
                                        onClick={() => toggleTab("7")}
                                    >
                                        Applications
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        className={activeTab === '10' ? 'active' : ''}
                                        onClick={() => toggleTab('10')}
                                    >
                                        Activity
                                    </NavLink>
                                </NavItem>
                            </Nav>
                            <TabContent activeTab={activeTab}>
                                <TabPane tabId="1" className="first_tab">
                                    <h3>Personal Information</h3>
                                    <Row className="info_blocck m-0">
                                        <Col sm="4" className="mb-3">
                                            <p>Full Name</p>
                                            <h6>{patientDetails?.name?.text}</h6>
                                        </Col>
                                        <Col sm="4" className="mb-3">
                                            <p>Primary Phone</p>
                                             {patientDetails?.telecom?.find(t => t.system === 'homePhone')?.value && (
                                                <h6>{patientDetails?.telecom?.find(t => t.system === 'homePhone')?.value}</h6>
                                                )}
                                        </Col>
                                        <Col sm="4" className="mb-3">
                                            <p>Social Security Number (SSN)</p>
                                            <h6>{patientDetails && maskSSN(patientDetails?.socialSecurityNumber)}</h6>
                                        </Col>
                                        <Col sm="4" className="mb-3">
                                            <p>Address</p>
                                            {patientDetails?.address && (
                                            <h6>
                                                {[patientDetails.address.city, patientDetails.address.state]
                                                .filter(Boolean)
                                                .join(", ") +
                                                (patientDetails.address.postalCode ? ` - ${patientDetails.address.postalCode}` : "")
                                                }
                                            </h6>
                                            )}
                                        </Col>
                                        <Col sm="4" className="mb-3">
                                            <p>Secondary Phone</p>
                                            {patientDetails?.telecom?.find(t => t.system === 'phone')?.value && (
                                                <h6>{patientDetails?.telecom?.find(t => t.system === 'phone')?.value}</h6>
                                                )}
                                        </Col>
                                        {/* <Col sm="4" className="mb-3">
                                            <p>I do not qualify for SSN</p>
                                            <h6><Input type="checkbox" checked={patientDetails?.socialSecurityNumber} disabled /></h6>
                                        </Col> */}
                                        <Col sm="4" className="mb-3">
                                        <p>Taxpayer Identification Number (ATIN/ITIN)</p>
                                            <h6>{maskString(patientDetails?.taxPayerNumber)}</h6>
                                        </Col>
                                        <Col sm="4" className="mb-3">
                                            <p>Email</p>
                                           {patientDetails?.telecom?.find(t => t.system === 'email')?.value && (
                                                <h6>{patientDetails?.telecom?.find(t => t.system === 'email')?.value}</h6>
                                                )}
                                        </Col>
                                        <Col sm="4" className="mb-3">
                                            <p>Marital Status</p>
                                            <h6>{patientDetails && patientDetails?.maritalStatus}</h6>
                                        </Col>
                                        <Col sm="4" className="mb-3">
                                            <p>Pregnant</p>
                                            <h6>{patientDetails?.isPregnant ? 'Yes' : 'No'}</h6>
                                        </Col>
                                        <Col sm="4" className="mb-3">
                                            <p>Disability</p>
                                            <h6>{patientDetails?.isDisable ? 'Yes' : 'No'}</h6>
                                        </Col>
                                        <Col sm="4" className="mb-3">
                                            <p>Immigration Status</p>
                                            <h6>
                                            {
                                                legalImmigrationOptions.find(
                                                option => option.value === patientDetails?.isLegalImmigrant
                                                )?.label || 'N/A'
                                            }
                                            </h6>
                                        </Col>
                                        <Col sm="4" className="mb-3">
                                            <p>Veteran</p>
                                            <h6>{patientDetails?.isVeterian ? 'Yes' : 'No'}</h6>
                                        </Col>
                                        <Col sm="4" className="mb-3">
                                            <p>US Citizen</p>
                                            <h6>{patientDetails?.isUsCitizen ? 'Yes' : 'No'}</h6>
                                        </Col>
                                        <Col sm="4" className="mb-3">
                                            <p>Department Approval Status</p>
                                            <h6>{patientDetails?.departmentAprvlStatus}</h6>
                                        </Col>
                                        <Col sm="4" className="mb-3">
                                            <p>Medicaid Eligibility Group</p>
                                            <h6>
                                                {(Array.isArray(patientDetails?.medicaidElegibitlyGroup))
                                                ? patientDetails.medicaidElegibitlyGroup.join(", ")
                                                : " "}
                                            </h6>
                                        </Col>
                                        <Col sm="4" className="mb-3">
                                            <p>Medicaid Enrollment Status</p>
                                            <h6>{enrollmentOptions.find(option => option.value === patientDetails?.medicaidEnrollmentStatus)?.label || '-'}</h6>
                                        </Col>
                                    </Row>
                                </TabPane>
                                <TabPane tabId="2"><>
                                    <AddHouseHold patientDeatils={patientDetails} toggleTab={toggleTab} />
                                </>
                                </TabPane>
                                <TabPane tabId="3" className="second_tab">
                                    <DocumentList patientDeatils={patientDetails} />
                                </TabPane>
                                <TabPane tabId="4" className="first_tab">
                                    <h3>Emergency Contact Information</h3>
                                    <Row className="info_blocck m-0">
                                        <Col sm="6" className="mb-3">
                                            <p>Emergency Contact Name</p>
                                            <h6>{patientDetails?.emergencyContacts?.name}</h6>
                                        </Col>
                                        <Col sm="6" className="mb-3">
                                            <p>Alternate Emergency Contact Name</p>
                                            <h6>{patientDetails?.emergencyContacts?.alternateName}</h6>
                                        </Col>
                                        <Col sm="6" className="mb-3">
                                            <p>Relationship</p>
                                            <h6>{patientDetails?.emergencyContacts?.relationship}</h6>
                                        </Col>
                                        <Col sm="6" className="mb-3">
                                            <p>Relationship</p>
                                            <h6>{patientDetails?.emergencyContacts?.alternateReln}</h6>
                                        </Col>
                                        <Col sm="6" className="mb-3">
                                            <p>Phone Number</p>
                                            <h6>{patientDetails?.emergencyContacts?.phone}</h6>
                                        </Col>
                                        <Col sm="6" className="mb-3">
                                            <p>Phone Number</p>
                                            <h6>{patientDetails?.emergencyContacts?.alternatePhone}</h6>
                                        </Col>
                                        <Col sm="6" className="mb-3">
                                            <p>Secondary Phone Number</p>
                                            <h6>{patientDetails?.emergencyContacts?.secondaryPhone}</h6>
                                        </Col>
                                        <Col sm="6" className="mb-3">
                                            <p>Secondary Phone Number</p>
                                            <h6>{patientDetails?.emergencyContacts?.alternateSecondaryPhone}</h6>
                                        </Col>
                                        <Col sm="6" className="mb-3">
                                            <p>Email</p>
                                            <h6>{patientDetails?.emergencyContacts?.email}</h6>
                                        </Col>
                                        <Col sm="6" className="mb-3">
                                            <p>Email</p>
                                            <h6>{patientDetails?.emergencyContacts?.alternateEmail}</h6>
                                        </Col>
                                        <Col sm="6" className="mb-3">
                                            <p>Language Preference</p>
                                            <h6>{patientDetails?.emergencyContacts?.languagePreference && Array.isArray(patientDetails.emergencyContacts.languagePreference) && (
                                                <ul>
                                                    {patientDetails.emergencyContacts.languagePreference.map((preference, index) => (
                                                        <li key={index}>{preference}</li>
                                                    ))}
                                                </ul>)}
                                            </h6>
                                        </Col>
                                        <Col sm="6" className="mb-3">
                                            <p>Language Preference</p>
                                            <h6>{patientDetails?.emergencyContacts?.alternatelanguagePreference && Array.isArray(patientDetails.emergencyContacts.alternatelanguagePreference) && (
                                                <ul>
                                                    {patientDetails.emergencyContacts.alternatelanguagePreference.map((preference, index) => (
                                                        <li key={index}>{preference}</li>
                                                    ))}
                                                </ul>)}
                                            </h6>
                                        </Col>
                                        <Col sm="6" className="mb-3">
                                            <p>Preferred Contact Method</p>
                                            <h6>{patientDetails?.emergencyContacts?.preferredContactMethod && Array.isArray(patientDetails.emergencyContacts.preferredContactMethod) && (
                                                <ul>
                                                    {patientDetails.emergencyContacts.preferredContactMethod.map((preference, index) => (
                                                        <li key={index}>{preference}</li>
                                                    ))}
                                                </ul>)}</h6>
                                        </Col>
                                        <Col sm="6" className="mb-3">
                                            <p>Preferred Contact Method</p>
                                            <h6>{patientDetails?.emergencyContacts?.alternatepreferredContactMethod && Array.isArray(patientDetails.emergencyContacts.alternatepreferredContactMethod) && (
                                                <ul>
                                                    {patientDetails.emergencyContacts.alternatepreferredContactMethod.map((preference, index) => (
                                                        <li key={index}>{preference}</li>
                                                    ))}
                                                </ul>)}</h6>
                                        </Col>
                                    </Row>
                                </TabPane>
                                <TabPane tabId="6" className="first_tab">
                                    <AddPatientPortal patientDeatils={patientDetails} />
                                </TabPane>
                                <TabPane tabId="5" className="first_tab">
                                    <Row>
                                        <Col sm="12" className="mb-3">
                                            <h3>Primary Insurance Information</h3>
                                        </Col>

                                        <Col sm={6} className="mb-3">
                                            <p>Name of the beneficiary</p>
                                            <h6>{patientDetails?.insuranceDetails?.beneficiaryName}</h6></Col>
                                        <Col sm={6} className="mb-3">
                                            <p>Insurance Company</p>
                                            <h6>{patientDetails?.insuranceDetails?.company}</h6></Col>
                                        <Col sm={6} className="mb-3">
                                            <p>Member ID/Policy Number</p>
                                            <h6>{patientDetails?.insuranceDetails?.policyNumber}</h6></Col>
                                        <Col sm={6} className="mb-3">
                                            <p>Group Number</p>
                                            <h6>{patientDetails?.insuranceDetails?.groupNumber}</h6></Col>
                                        <Col sm={6} className="mb-3">
                                            <p>Plan Type</p>
                                            <h6>{patientDetails?.insuranceDetails?.planType}</h6></Col>
                                        <Col sm={6} className="mb-3">
                                            <p>Effective Date</p>
                                            <h6>{patientDetails?.insuranceDetails?.effectiveDate}</h6></Col>
                                    </Row>

                                    <Row>
                                        <Col sm="12" className="mb-3">
                                            <h3 className="info_blocck">Secondary Insurance Information</h3>
                                        </Col>
                                        <Col sm={6} className="mb-3">
                                            <p>Name of the beneficiary</p>
                                            <h6>{patientDetails?.insuranceDetails?.alternateBeneficiaryName}</h6>
                                        </Col>
                                        <Col sm={6} className="mb-3">
                                            <p>Insurance Company</p>
                                            <h6>{patientDetails?.insuranceDetails?.alternateCompany}</h6></Col>
                                        <Col sm={6} className="mb-3">
                                            <p>Member ID/Policy Number</p>
                                            <h6>{patientDetails?.insuranceDetails?.alternatePolicyNumber}</h6></Col>
                                        <Col sm={6} className="mb-3">
                                            <p>Group Number</p>
                                            <h6>{patientDetails?.insuranceDetails?.alternateGroupNumber}</h6></Col>
                                        <Col sm={6} className="mb-3">
                                            <p>Plan Type</p>
                                            <h6>{patientDetails?.insuranceDetails?.alternatePlanType}</h6></Col>
                                        <Col sm={6} className="mb-3">
                                            <p>Effective Date</p>
                                            <h6>{patientDetails?.insuranceDetails?.alternateEffectiveDate}</h6></Col>
                                    </Row>
                                </TabPane>
                            <TabPane tabId="7" className="first_tab">
                                <div className='d-flex add_app_header mb-5'>
                                    <button
                                        className={`${statusFilter === 'InProcess' ? 'in_progress' : 'closed'}`}
                                        onClick={() => handleStatusChange('InProcess')}>In Progress</button>
                                    <button
                                        className={` ${statusFilter === 'Closed' ? 'in_progress' : 'closed'}`}
                                        onClick={() => handleStatusChange('Closed')}>Closed</button>
                                </div>
                                <AddApplications getPatient={() => getPatient()} patientDeatils={patientDetails} statusFilter={statusFilter} />
                            </TabPane>
                            <TabPane tabId="9">
                                <h4>Tab 8 Contents</h4>
                            </TabPane>
                            <TabPane tabId="9">
                                <h4>Tab 9 Contents</h4>
                            </TabPane>
                            <TabPane tabId="10">
                                {patientDetails?._id && <PatientActivity patientDeatils={patientDetails} activeTab={activeTab} />}
                            </TabPane>
                        </TabContent>
                    </div>
                </div>
                <div className="d-flex gap-3 justify-content-center mt-3 mb-3">
                    <button className="save_btn_blockk" type="submit" onClick={() => navigate(-1)}>Back</button>
                </div>
            </div>
        </div >
        </>
    );
};

export default PatientProfile;
